module.exports = __webpack_public_path__ + "img/menu1-3.f903dacd.jpg";